import { TRACEABILITY_GRAPH_MAX_VISIBLE_ITEMS, TRACEABILITY_GRAPH_NODE_CONFIG } from '@v2/pages/common/components/TraceabilityGraph/constants';
import { LinkItem, TraceabilityEntitySummary, TraceabilityNode, TraceabilityNodeType } from '@v2/pages/common/components/TraceabilityGraph/types';

export const notEmpty = <T,>(item: T | null | undefined | false): item is T => Boolean(item);

// Keep testIDs safe; hyphen is last in the class so it stays a literal, not a range.
export const normalizeNodeId = (value: string) => value.replace(/[^a-zA-Z0-9_-]/g, '-');

export const createSummaryNode = (type: TraceabilityNodeType, count: number): TraceabilityNode => ({
  id: count,
  nodeId: `${type}-more`,
  type: TraceabilityNodeType.SUMMARY,
  eyebrow: 'More linked items',
  title: `+${count}`,
  subtitle: 'Open source tabs for the full list',
  icon: TRACEABILITY_GRAPH_NODE_CONFIG[TraceabilityNodeType.SUMMARY].icon,
  disabled: true,
});

export const limitNodes = (nodes: TraceabilityNode[], type: TraceabilityNodeType) => {
  const visibleNodes = nodes.slice(0, TRACEABILITY_GRAPH_MAX_VISIBLE_ITEMS);
  const hiddenCount = nodes.length - visibleNodes.length;

  return hiddenCount > 0 ? [...visibleNodes, createSummaryNode(type, hiddenCount)] : visibleNodes;
};

export const uniqueById = (items: TraceabilityEntitySummary[]) => {
  const map = new Map<number, TraceabilityEntitySummary>();

  items.forEach((item) => {
    if (!map.has(item.id)) {
      map.set(item.id, item);
    }
  });

  return [...map.values()];
};

export const getFirstLinkWithPart = (links: LinkItem[]) => links.find((link) => link?.partId != null);

export const joinTraceSubtitle = (items: (string | null | undefined | false)[]) => items.filter(notEmpty).join(' - ');
